<template>
  <SubscriptionConsumptionHistoryTable
    :title="$t(`${TRANSLATION_KEY_PREFIX}.title`)"
    :headers="headers"
    :rows="rows"
    :pending="subscriptionDrPlanHistoryPending"
    :error="!!subscriptionDrPlanHistoryError"
    :error-text="$t(`${TRANSLATION_KEY_PREFIX}.error`)"
    :empty-title="$t(`${TRANSLATION_KEY_PREFIX}.emptyState.title`)"
    data-locator="subscription-consumption-history"
    row-locator="history-row"
    :pagination-key="SUBSCRIPTION_DR_PLAN_HISTORY_ITEMS_PER_PAGE"
  />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState, mapActions } from 'vuex'

  import { formatPrice } from '@/common/utils/currency'
  import { ISOToDDMMYYYY } from '@/common/utils/dates'
  import { toast } from '@/common/utils/toast'
  import { GET_SUBSCRIPTION_DR_PLAN_HISTORY } from '@/store/modules/subscription/action_types'
  import { SUBSCRIPTION_DR_PLAN_HISTORY_ITEMS_PER_PAGE } from '@/subscriptions/constants.js'
  import SubscriptionConsumptionHistoryTable from '@/subscriptions/views/SubscriptionConsumptionHistoryTable.vue'
  import type { SubscriptionDrPlanHistoryItem } from '@/types/subscription'

  const TRANSLATION_KEY_PREFIX = 'subscriptions.views.SubscriptionConsumption.History'

  export default defineComponent({
    name: 'SubscriptionConsumptionDrPlanHistory',
    components: { SubscriptionConsumptionHistoryTable },
    data () {
      return {
        TRANSLATION_KEY_PREFIX,
        SUBSCRIPTION_DR_PLAN_HISTORY_ITEMS_PER_PAGE,
      }
    },
    computed: {
      ...mapState('subscription', [
        'subscriptionDrPlanHistory',
        'subscriptionDrPlanHistoryPending',
        'subscriptionDrPlanHistoryError',
      ]),
      headers () {
        return [
          { title: this.$t(`${TRANSLATION_KEY_PREFIX}.headers.date`), key: 'date', sortable: false },
          { title: this.$t(`${TRANSLATION_KEY_PREFIX}.headers.description`), key: 'description', sortable: false },
          { title: this.$t(`${TRANSLATION_KEY_PREFIX}.headers.price`), key: 'price', sortable: false },
        ]
      },
      rows () {
        const history = (this.subscriptionDrPlanHistory ?? []) as SubscriptionDrPlanHistoryItem[]
        return [...history]
          .sort((a, b) => (a.date === b.date ? b.id - a.id : b.date.localeCompare(a.date)))
          .map(item => ({
            id: item.id,
            date: ISOToDDMMYYYY(item.date),
            description: this.$t(`${TRANSLATION_KEY_PREFIX}.description`, { limitGb: item.drPlanLimitGb }),
            price: formatPrice(item.amountNet),
          }))
      },
    },
    created () {
      this.getSubscriptionDrPlanHistory()
    },
    methods: {
      ...mapActions('subscription', [GET_SUBSCRIPTION_DR_PLAN_HISTORY]),
      async getSubscriptionDrPlanHistory () {
        try {
          await this.GET_SUBSCRIPTION_DR_PLAN_HISTORY()
        } catch {
          toast.error(this.$t(`${TRANSLATION_KEY_PREFIX}.error`))
        }
      },
    },
  })
</script>
